import { render } from "./conferenceLayout.vue?vue&type=template&id=6be215d2"
const script = {}

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__